<div class="reporting-stations-dashboard">
  <sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">

    <sc-padding>
      <sc-flex>
        <span class="item" (click)="back()"><sc-icon iconClass="fa-chevron-left"></sc-icon></span>
        <span class="item">{{selectedDate | date: 'dd.MM.yyyy'}}</span>
        <span class="item" (click)="forward()"><sc-icon iconClass="fa-chevron-right"></sc-icon></span>
        <sc-content-spacer></sc-content-spacer>
        <button class="item margin-left-25" mat-stroked-button (click)="printHourlyReport()">
          {{'print' |translate:['reporting.station-occupancy.action.print-hourly', translationService.language]}}
        </button>
      </sc-flex>
    </sc-padding>

    <sc-content-spacer [vertical]="true"></sc-content-spacer>

    <sc-flex-fitting-content [vertical]="true">
      <ng-container *ngIf="data != null && this.data.chartSvg">
        <sc-padding [fitHeight]="true">
          <div class="svg-chart" [innerHtml]="this.data.chartSvg | trustHtml"></div>
        </sc-padding>
      </ng-container>
    </sc-flex-fitting-content>

  </sc-flex>

</div>